export default class InputRules{
    combi_rule(max){
        // return [
        //     value => !!value || 'Required.',
        //     // value => (value && value.length >= max) || "Min " + max + " characters",
        //     value => (value && value.length == max) || "Max " + max + " characters",
        // ]
        return [
            value => value.length <= 20 || 'Max 20 characters',
            // email: value => {
            //     const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            //     return pattern.test(value) || 'Invalid e-mail.'
            // },
        ];
    }

    isNumber(evt){
        evt = (evt) ? evt : window.event
        let charCode = (evt.which) ? evt.which : evt.keyCode
  
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
    }

    
}